<template lang="html">
  <div class="detail-container" v-if="html_show">
    <div class="table">
      <div class="row">
        <p class="col-header">发文机关</p>
        <p class="col-content">{{detail.publish_org}}</p>
      </div>
      <div class="row">
        <p class="col-header">发文字号</p>
        <p class="col-content">{{detail.code | empty}}</p>
      </div>
      <div class="row">
        <p class="col-header">发文时间</p>
        <p class="col-content">{{detail.publish_time | timeTrans}}</p>
        <p class="col-header">有效时间</p>
        <p class="col-content">{{detail.execute_time | timeTrans}}</p>
      </div>
      <div class="row">
        <p class="col-header">有效地区</p>
        <p class="col-content">{{detail.address_id | addressPeggingPrintf(address, '-')}}</p>
        <p class="col-header">时效性</p>
        <p class="col-content">{{detail.available | empty}}</p>
      </div>
    </div>
    <div class="content">
      <p class="title">{{detail.name}}</p>
      <p class="code" v-if="detail.code">{{detail.code}}</p>
      <div class="desc" v-html="detail.unsined_content"></div>
    </div>
  </div>
  <Loading v-else="!html_show"></Loading>
</template>

<script>
import { policyDetail, getMeta } from '../service'
import Loading from '@/views/Mobile/components/loading.vue'
export default {
  data() {
    return {
      detail: '',
      address: [],
      html_show: false
    }
  },
  components: {
    Loading
  },
  methods: {
    async getDetail() {
      let res = await policyDetail({uid: this.$route.params.uid}, (error) => {this.$Message.error('请求错误')})
      if (res.status == 'success') {
        this.detail = res.res
        this.html_show = true
      } else {
        this.$Message.error(res.message)
      }
    },
    async getMeta() {
      let res = await getMeta({
        name: ['address']
      })
      if (res.status == 'success') {
        this.address = res.meta.address
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    this.getDetail()
    this.getMeta()
  }
}
</script>

<style lang="stylus" scoped>
.detail-container
  padding: .4rem;
  .table
    border: 1px solid #F3F3F3;
    .row
      display: flex;
      .col-header
        width: 1.56rem;
        padding: 0 .3rem;
        vertical-align: middle;
        background: #FFFAF6;
        color: #666666;
        font-size: .24rem;
        font-weight: bold;
        display: flex;
        align-items: center;
      .col-content
        flex: 1;
        line-height: .34rem;
        padding: .2rem;
        font-size: .24rem;
        display: flex;
        align-items: center;
        color: #333333;
    .row+.row
      border-top: 1px solid #F3F3F3;
  .content
    margin-top: .56rem;
    .title
      color: #333333;
      font-size: .48rem;
      font-weight: bold;
      line-height: .64rem;
    .code
      margin-top: .2rem;
      color: #999999;
      font-size: .28rem;
      text-align: center;
    .desc
      margin-top: .2rem;
      color: #333333;
      font-size: .32rem;
      line-height: .6rem;
</style>
